import { hasAnyRole } from './permissions'

/**
 * The route of `path` in a route table (routes/routes.js shape: `path`,
 * `roles`, nested `routes` with relative paths), or null. Exact paths only:
 * the links it is asked about have no parameters.
 *
 * @param {object[]} table
 * @param {string} path
 */
export const findRoute = (table, path) => {
    const walk = (list, prefix) => {
        for (const route of list || []) {
            const full = route.path.startsWith('/')
                ? route.path
                : `${prefix}/${route.path}`
            if (full === path) return route
            const child = walk(route.routes, full)
            if (child) return child
        }
        return null
    }
    return walk(table, '')
}

/**
 * True when a user holding `permissions` may open `path`: the route exists
 * and its own `roles` admit them (as RequireRoles decides). A link to a path
 * with no route is never offered.
 *
 * @param {object[]} table        the route table
 * @param {string} path
 * @param {string[]} permissions  the user's groups
 */
export const canOpenPath = (table, path, permissions) => {
    const route = findRoute(table, path)
    return !!route && hasAnyRole(permissions, route.roles)
}
